// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1FIgn","container":"styles_container__2WRO9","title":"styles_title__2kDt8","wrapper":"styles_wrapper__XStbG","answer":"styles_answer__6U-5r"};